// DroppableContainer Component
import { DropTarget as dropTarget } from 'react-dnd'
import React, { Component } from 'react'
import PropTypes from 'prop-types'

const itemTarget = {
  drop (props, monitor) {
    const item = monitor.getItem()
    if (props.onDropItem) {
      props.onDropItem(item)
    }
  }
}

@dropTarget((_props) => 'all', itemTarget, (connect, monitor) => ({
  connectDropTarget: connect.dropTarget(),
  isOver: monitor.isOver(),
  canDrop: monitor.canDrop()
}))
class DroppableContainer extends Component {
  static get propTypes () {
    return {
      active: PropTypes.bool,
      isOver: PropTypes.bool,
      connectDropTarget: PropTypes.func,
      canDrop: PropTypes.bool,
      children: PropTypes.any,
      onDropItem: PropTypes.func
    }
  }

  static get defaultProps () {
    return {
      active: false,
      isOver: false,
      connectDropTarget: null,
      canDrop: false,
      onDropItem: null
    }
  }

  constructor (props) {
    super(props)

    this.data = {
      active: props.active
    }
  }

  render () {
    const { connectDropTarget, children } = this.props
    return connectDropTarget(
      <div
        className={`cdroppable-container${this.data.active ? ' active' : ''}`}
      >
        {children}
      </div>
    )
  }

  show () {
    this.data.active = true
    this.setState({ dataDate: new Date() })
  }

  hide () {
    this.data.active = false
    this.setState({ dataDate: new Date() })
  }
}

export default DroppableContainer
